<template>
  <div class="header">
    <div class="header_title">
      <p>{{message}}</p>
      <span></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Cooperation',
  data() {
    return {

    }
  },
  props: ["message", "colors"]
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media screen and (max-width:1605px) {
  /*当屏幕尺寸小于600px时，应用下面的CSS样式*/
  .header_title {
    padding-top: 80px;
    text-align: center;
  }
}

@media screen and (min-width:1606px) {
  .header_title {
    padding-top: 180px;
    text-align: center;
  }
}

@media screen and (max-width:1330px) {
  .header_title {
    padding-top: 50px;
    text-align: center;
  }
}

@media screen and (min-width:1520px) and (max-width:1604px) {
  .header_title {
    padding-top: 180px;
    text-align: center;
  }
}

.header_title p {
  margin: 0px auto;
  letter-spacing: 1px;
  min-width: 700px;
  text-align: center;
  height: 30px;
  font-size: 36px;
  /* font-family: PingFangSC-Semibold; */
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}

.header_title span {
  display: inline-block;
  width: 40px;
  border-bottom: 3px solid red;
  margin-top: 23px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/header.vue